export const ScrollerConstants = {
  SET_SCROLL_OFFSET: 'SCROLLER_SET_SCROLL_OFFSET'
}